module.exports = __webpack_public_path__ + "img/home_qiandao_icon.f7d3913c.png";